import { useState } from 'react';
import { AppRoute } from '@/App';
import { useNavigate } from 'react-router-dom';
import { authService } from '@/services/authService';

export interface LoginScreenViewModel {
  // Состояние формы
  email: string;
  password: string;
  passwordVisible: boolean;
  loading: boolean;
  // Состояние ошибок
  emailError: string | null;
  passwordError: string | null;
  error: string | null;

  
  // Методы управления формой
  setEmail: (email: string) => void;
  setPassword: (password: string) => void;
  togglePasswordVisibility: () => void;
  
  // Методы валидации
  validateEmail: (email: string) => string | null;
  validatePassword: (password: string) => string | null;
  validateForm: () => boolean;
  
  // Методы навигации
  handleSubmit: () => void;
  navigateToRegister: () => void;
  navigateToForgotPassword: () => void;
}

export const useLoginScreenViewModel = (): LoginScreenViewModel => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [emailError, setEmailError] = useState<string | null>(null);
  const [passwordError, setPasswordError] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const validateEmail = (email: string): string | null => {
    if (!email.trim()) {
      return "Введите email";
    }
    if (!email.includes("@")) {
      return "Введите правильный email";
    }
    return null;
  };

  const validatePassword = (password: string): string | null => {
    if (!password.trim()) {
      return "Введите пароль";
    }
    if (password.length < 8) {
      return "Пароль должен содержать не менее 8 символов";
    }
    return null;
  };

  const validateForm = (): boolean => {
    const emailValidation = validateEmail(email);
    const passwordValidation = validatePassword(password);
    
    setEmailError(emailValidation);
    setPasswordError(passwordValidation);
    
    return !emailValidation && !passwordValidation;
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleSubmit = async () => {
    if (validateForm()) {
      try {
        setLoading(true);
        await authService.signIn(email, password);
      } catch (error: any) {
        console.log(error);
        if (error.response.status === 401) {
          setError("Неверный email или пароль");
        } else {
          setError("Произошла ошибка");
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const navigateToRegister = () => {
    navigate(AppRoute.Register);
  };

  const navigateToForgotPassword = () => {
    navigate(AppRoute.ForgotPassword);
  };

  return {
    email,
    password,
    passwordVisible,
    emailError,
    passwordError,
    error,
    loading,
    setEmail,
    setPassword,
    togglePasswordVisibility,
    validateEmail,
    validatePassword,
    validateForm,
    handleSubmit,
    navigateToRegister,
    navigateToForgotPassword,
  };
}; 
